import ExternalSync from "../";

const routes = [
    { name: "ExternalSync", path: "/externalsync", component: ExternalSync.ExternalSyncPage, meta: { title: "Externa Sync" } },
    // { name: "ExternalSyncModule", path: "/hl7integratorserver", component: Hl7Integrator.Hl7IntegratorServer, meta: { title: "HL7 Integrator Server" } },
    // { name: "ExternalSyncLog", path: "/hl7integratorclient", component: Hl7Integrator.Hl7IntegratorClient, meta: { title: "HL7 Integrator Client" } },
];
export default routes;
